import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import keycode from 'keycode';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import SweetAlert from 'react-bootstrap-sweetalert';
import PopupState, { bindMenu, bindTrigger, bindPopover } from 'material-ui-popup-state';
import Menu from "@material-ui/core/Menu";
import MenuItem from '@material-ui/core/MenuItem';
import InputVirtual from 'components/InputVirtual'
import DialogAdd from './DialogAdd';
import DialogEdit from './DialogEdit';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import moment from 'moment';
import { Divider } from '@material-ui/core';
import CardBox from 'components/CardBox';
import ReactToExcel from 'react-html-table-to-excel';
import LinearProgress from '@material-ui/core/LinearProgress';
import { BASE_URL_JAVAZ_API, BASE_URL_APIv4, BASE_URL_API } from "constants/ActionTypes";


const companyId = localStorage.getItem('companyId')
const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 25
const URL_SEARCH = `${BASE_URL_JAVAZ_API}/driver/search`
const masterTitleCapital = "Operator";
const masterTitle = "driver";

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const dataSearch = [
    {
        fieldname: 'name',
        alias: 'Nama',
        field: { type: 'basic', api: '' },
        searchAble: true,
        width: ''
    },
    {
        fieldname: 'company',
        alias: 'Perusahaan',
        field: { type: 'basic', api: '' },
        searchAble: true,
        width: ''
    },
    {
        fieldname: 'customerpoint',
        alias: 'Customer Point',
        field: { type: 'virtual', api: '' },
        searchAble: true,
        width: ''
    },
    {
        fieldname: 'vehicle',
        alias: 'Vehicle',
        field: { type: 'basic', api: '' },
        searchAble: false,
        width: ''
    }
]

const options = [
    'Nama',
    'License Plate',
    'Callisto',
    'Dione',
];

const columnData = [
    { label: 'Perusahaan' },
    { label: 'Nama' },
    { label: 'Tipe Lisensi' },
    { label: 'Kode RFID' },
    { label: 'Absen' },
    { label: 'Status' },
];

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
    button: {
        //   margin: theme.spacing.unit,
        margin: '0px',
    },
    buttonExport: {
        marginRight: '0px',
        // margin: '20px',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});


class MasterDriver extends React.Component {

    renderSearch = () => {
        const { data, totalRecord } = this.state
        return dataSearch.map(res => {
            if (res.searchAble === true) {
                if (res.field.type === 'basic') {
                    return (
                        <Grid item xs={4}>
                            <TextField
                                // id="standard-normal"
                                label="asda"
                                defaultValue="foo"
                                margin="normal"
                            />
                        </Grid>
                    )
                } else {
                    if (data.length > 0) {
                        return (
                            <Grid item xs={4}>
                                <InputVirtual
                                    countRecord={totalRecord}
                                    recordData={data}
                                    loadRows={this._loadMoreRows}
                                    inputText={this.handleInputDialog}
                                    getData={this.getCompany}
                                />
                            </Grid>
                        )
                    }
                }
            }
        })

    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleInputDialog = async (e) => {
        const value = e.target.value
        const result = await axios.get(`${BASE_URL_APIv4}/transit-point?apiKey=b21df387-19fb-498b-90b3-94184c50a304&start=0&length=20&&params={"name":"${value}"}`)
            .then(res => res.data)
            .catch((error) => error.response)
        if (result.data.length !== 0) {
            this.setState({ dataRecord: result.data, totalRecord: result.totalRecord });
        }
    }

    async _loadMoreRows({ startIndex, stopIndex }) {
        const { indexStart } = this.state
        const start = indexStart + 20
        const data = await axios.get(`${BASE_URL_APIv4}/transit-point?apiKey=b21df387-19fb-498b-90b3-94184c50a304&start=${start}&length=20`)
            .then(res => res.data.data)
            .catch((error) => error.response)
        this.setState({ dataDriver: [...this.state.dataRecord, ...data], indexStart: start })
    }

    getCompany = (data) => {
        this.setState({ company: data })
    }

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    handleMasterDriver = async (start, length) => {
        const data = {
            paging: { start: start, length: length },
            orders: { columns: ["id"], ascending: false },
            joins: [
                { name: "company", column_results: ["name"] },
                { name: "vehicle", column_results: ["license_plate"] },
                { name: "driver_license", column_results: ["license_name"] },
            ],
            columns: [
                ... this.state.searchTableName.toString() !== "" ? [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND", "table_name": this.state.searchTableName }] :
                    [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND" }]
            ],

        }
        let objDD = JSON.stringify(data)
        const result = await axios.post(URL_SEARCH, objDD, config).then(res => res).catch(error => error.response)
        // console.log(result)
        if (result.data.code === 200) {
            this.setState({
                dataDriver: result.data.data, totalRecordDriver: result.data.totalRecord, indexDataDriver: 0,
            })
        }
    }

    handleRequestDataExport = async () => {
        const data = {
            paging: { start: 0, length: -1 },
            orders: { columns: ["name"], ascending: true },
            joins: [
                { name: "company", column_results: ["name"] },
                { name: "vehicle", column_results: ["license_plate"] },
                { name: "driver_license", column_results: ["license_name"] },
            ],
            columns: [
                ... this.state.searchTableName.toString() !== "" ? [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND", "table_name": this.state.searchTableName }] :
                    [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND" }]
            ],

        }

        let objDD = JSON.stringify(data)
        const result = await axios.post(URL_SEARCH, objDD, config).then(res => res).catch(error => error.response)
        // // console.log('dataDriverExport ',result)
        if (result.data.code === 200) {
            this.setState({
                dataDriverExport: result.data.data, totalRecordDriver: result.data.totalRecord, indexDataDriver: 0,
            })
        }
        return true;
    }

    async componentDidMount() {
        await this.handleMasterDriver(0, this.state.rowsPerPage)
        await this.handleRequestDataExport()
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleChangePage = (event, page) => {
        this.setState({ page })
        if (this.state.page > this.state.lastIndex) this.setState({ lastIndex: page })
    };

    getMoreData = async () => {
        const { indexDataDriver } = this.state
        const start = indexDataDriver + LENGTH_DATA
        const data = {
            paging: { start: start, length: this.state.rowsPerPage },
            orders: { columns: ["name"], ascending: true },
            joins: [
                { name: "company", column_results: ["name"] },
                { name: "vehicle", column_results: ["license_plate"] },
                { name: "driver_license", column_results: ["license_name"] },
            ],
            columns: [
                ... this.state.searchTableName.toString() !== "" ? [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND", "table_name": this.state.searchTableName }] :
                    [{ name: this.state.searchDetailField, "logic_operator": "like", value: this.state.search, "operator": "AND" }]
            ],
        }
        let objDD = JSON.stringify(data)
        const result = await axios.post(URL_SEARCH, objDD, config).then(res => res).catch(error => error.response)
        // console.log(result)
        if (result.data.code === 200) {
            if (result.data.totalRecord > 0) {
                this.setState({ indexDataDriver: start })
            } else {
                this.setState({ indexDataDriver: 0 })
            }
        }

        return result.data.data
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.page >= this.state.page) {
        } else {
            if (prevState.page > this.state.lastIndex) {
            } else {
                const data = await this.getMoreData()
                this.setState({ dataDriver: [...this.state.dataDriver, ...data] })
            }

        }

        if (this.state.search !== prevState.search) this.handleMasterDriver(0, this.state.rowsPerPage)
    }
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;
    constructor(props, context) {
        super(props, context);

        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: [],
            dataDriver: [],
            dataDriverExport: [],
            totalRecordDriver: [],
            // indexDataDriver: [],
            indexDataDriver: 0,
            totalRecord: 0,
            page: 0,
            rowsPerPage: LENGTH_DATA,
            // indexData: 20,
            lastIndex: 0,
            search: '',
            open: false,
            company: '',
            openAdd: false,
            openEdit: false,
            sweetSuccess: false,
            sweetWarning: false,
            idDelete: null,
            idEdit: null,
            dataEdit: null,
            company_name: '',
            openQr: false,
            urlQr: '',
            openPhoto: false,
            urlPhoto: '',
            nameQr: '',
            searchDetail: 'Nama',
            searchDetailField: 'name',
            searchTableName: '',
            loading: false,
        };

        this._loadMoreRows = this._loadMoreRows.bind(this);
    }

    handleSearch = e => {
        this.setState({ search: e.target.value })
    }


    handleCloseDialog = param => {
        if (param === 'tambah') {
            this.handleMasterDriver(0, this.state.rowsPerPage)
        }
    };

    handleGetLicenseDetail = async id => {
        const data = {
            columns: [{ name: "driver_id", logic_operator: "=", value: `${id}`, operator: "AND" }],
            joins: [{ name: "driver_license", column_results: ["license_name"] }]
        }

        let objDD = JSON.stringify(data)
        const url = `${BASE_URL_JAVAZ_API}/driver-license-detail/search`
        const result = await axios.post(url, objDD, config).then(res => res).catch(error => error.response)
        return result
    }

    handleGetImage = async imageURL => {
        let getImage = await axios.head(imageURL).then(response => response).catch(error => error);

        // console.log('getImage', getImage);

        if (getImage == "Error: Request failed with status code 404") {
            // No image in directory
            // console.log('No image in directory', getImage);
            return 'assets/images/blank-image-photo.png'
        }
        else if (getImage.status == 200) {
            // There is an image in directory!
            // console.log('There is an image in directory!', getImage);
            return imageURL
        }
    }

    handleClickOpenEdit = async data => {
        Nprogress.start();
        const result = await this.handleGetLicenseDetail(data.id)
        // console.log(result)
        if (result.data.status === true) {
            const arr = []
            result.data.data.map(res => {

                const obj = {
                    id: res.id,
                    license_exp_date: moment(res.license_exp_date).format('YYYY-MM-DD'),
                    license_no: res.license_no,
                    driver_license: res.driver_license,
                    // front_photo: `${BASE_URL_API}/images/driver/${companyId}/license/front_photo/${data.id}_${res.driver_license}.png?apikey=${token}`,
                    // back_photo: `${BASE_URL_API}/images/driver/${companyId}/license/back_photo/${data.id}_${res.driver_license}.png?apikey=${token}`,
                    license_name: res.join.driver_license_license_name,
                }
                arr.push(obj)
            })

            const timeNow = new Date()
            const url = `${BASE_URL_API}/images/qr_img/driver/${companyId}/${data.id}.png?apikey=${token}`
            const urlPhoto = `${BASE_URL_API}/images/driver/${companyId}/${data.id}.png?apikey=${token}&${timeNow}`
            const urlImage = await this.handleGetImage(urlPhoto)

            const arr2 = { ...data, qrcode: url, photo: urlPhoto, driver_license: arr }
            // console.log(arr2)
            this.setState({ openEdit: true, dataEdit: arr2, idEdit: data.id })
        } else {
            NotificationManager.error(result.data.message, 'Error message')
        }
        Nprogress.done();
    }

    handleEditLicense = async data => {
        const { idEdit } = this.state
        let obj = JSON.stringify(data)
        const url = `${BASE_URL_JAVAZ_API}/driver/edit/${idEdit}`
        const result = await axios.put(url, obj, config).then(res => res).catch(error => error.response)
        return result
    }

    handleCloseEdit = async (param, data) => {
        const { dataEdit, dataDriver } = this.state
        if (param === 'batal') {
            // console.log(param)
            this.setState({ openEdit: false, dataEdit: null, });
        } else if (param === 'ubah') {
            this.setState({loading: true})
            const result = await this.handleEditLicense(data)
            // console.log(result)
            const res = result.data.data
            const idx = dataDriver.indexOf(dataEdit)

            if (result.data.status === true) {
                dataDriver.splice(idx, 1, res)
                this.setState({ openEdit: false, dataEdit: null, loading: false });
                NotificationManager.success('Edit Driver Success', 'Success message')
                this.handleMasterDriver(0, this.state.rowsPerPage)
            } else {
                this.setState({ loading: false })
                NotificationManager.error(result.data.message, 'Error message')
            }
        }

    };

    handleCloseSearch = (param) => {
        if (param === 'batal') {
            // console.log(param)
        } else if (param === 'apply') {
            // console.log(param)
        }
        this.setState({ open: false });
    };

    handleDeleteData = (data) => {
        // console.log(data)
        this.setState({ sweetWarning: true, idDelete: data })
    }

    onConfirm = () => {
        this.setState({
            sweetSuccess: false,
        });
    };

    doDeleteDriver = async data => {
        // console.log(data.id)
        const url = `${BASE_URL_JAVAZ_API}/driver/delete/${data.id}`
        const result = await axios.delete(url, config).then(res => res).catch(error => error.response)
        // console.log(result)
        return result
    }

    handleDelete = async param => {
        if (param === 'batal') {
            // console.log(param)
            this.setState({
                sweetWarning: false,
            })
        } else if (param === 'delete') {
            const { idDelete, dataDriver } = this.state
            this.setState({ loading: true })
            const result = await this.doDeleteDriver(idDelete)
            // console.log(result)
            if (result.data.status === true) {
                NotificationManager.success('Delete Driver Success', 'Success message')
                const idx = dataDriver.indexOf(idDelete)
                dataDriver.splice(idx, 1)
            } else {
                NotificationManager.error(result.data.message, 'Error message')
            }

            this.setState({
                sweetWarning: false,
                loading: false,
                dataDriver
            })
        }
    }

    handleViewQr = (data) => {
        const url = `${BASE_URL_API}/images/qr_img/driver/${companyId}/${data.id}.png?apikey=${token}`
        // console.log(url)
        this.setState({ openQr: true, urlQr: url, nameQr: data.name })
    }

    handleViewPhoto = async data => {
        let timeNow = new Date()
        const urlPhoto = `${BASE_URL_API}/images/driver/${companyId}/${data.id}.png?apikey=${token}&${timeNow}`
        console.log(urlPhoto)
        const urlImage = await this.handleGetImage(urlPhoto)
        this.setState({ openPhoto: true, urlPhoto: urlImage, namePhoto: data.name })
    }

    handleShowDialog = () => {
        this.showChildDialog();
    };

    render() {
        const { data, order, orderBy, selected, rowsPerPage, page, totalRecord, search, dataDriverExport, loading } = this.state;
        const { classes } = this.props

        return (
            <div className="app-wrapper">
                <div className="d-sm-flex justify-content-sm-between align-items-sm-center">
                    <div className="col-md-9">
                        <h2 className="title mb-3 mb-sm-0">
                            <span>{masterTitleCapital}</span>
                        </h2>
                    </div>
                    <div className="col-md-3 d-flex justify-content-between">
                        <nav className="mb-0">
                            {/* <ReactToExcel
                            className="jr-btn"
                            table="tabletoexcel"
                            sheet="report"
                            filename = "Export data driver"
                            buttonText="Export Pdf"/> */}
                        </nav>
                        <nav className="mb-sm-0">
                            <ReactToExcel
                                className="jr-btn"
                                table="tabletoexcel"
                                sheet="report"
                                filename="Export data driver"
                                buttonText="Export" />
                            <div style={{ display: 'none' }}>
                                <table border='1' id='tabletoexcel'>
                                    <thead>
                                        <tr>
                                            <th>Nama</th>
                                            <th>Email</th>
                                            <th>Nomor HP</th>
                                            <th>Kode RFID</th>
                                            <th>Perusahaan</th>
                                            <th>Alamat</th>
                                            <th>Absen</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {dataDriverExport !== null ?
                                            dataDriverExport.map((item, indeks) => {
                                                return (
                                                    <tr key={indeks}>
                                                        <td>{item.name}</td>
                                                        <td>{item.email}</td>
                                                        <td>{item.mobile_no}</td>
                                                        <td>{item.rfid}</td>
                                                        <td>{item.join.company_name}</td>
                                                        <td>{item.address}</td>
                                                        <td>{item.absent !== false ? "Yes" : "No"}</td>
                                                        <td>{item.status !== false ? "Active" : "Not Active"}</td>
                                                    </tr>
                                                )
                                            }) : null}
                                    </tbody>
                                </table>
                            </div>
                        </nav>
                    </div>
                </div>
                <hr></hr>
                <NotificationContainer />
                <SweetAlert show={this.state.sweetSuccess} success title='Success' onConfirm={this.onConfirm}>
                    Data was successfully deleted !
                </SweetAlert>
                <SweetAlert 
                    show={this.state.sweetWarning}
                    warning
                    showCancel
                    confirmBtnText={`${loading ? "Delete..." : "Yes Delete!"}`}
                    confirmBtnBsStyle={`${loading ? 'secondary' : 'danger'}`}
                    disabled={loading}
                    cancelBtnBsStyle="default"
                    title='Are You Sure?'
                    onConfirm={() => {
                        if (!loading) this.handleDelete('delete')
                    }}
                    onCancel={() => { 
                        if (!loading) this.handleDelete('batal')}
                    }
                >
                    {loading ? (
                        <div>
                            <div>Please Wait...</div>
                            <LinearProgress />
                        </div>
                  ) : "You want to delete this data!"}
                </SweetAlert>
                <Paper className={classes.paper} elevation={1}>
                    <Toolbar
                        className={classNames("table-header", {
                            ["highlight-light"]: selected.length > 0,
                        })}
                    >

                        <div className="title">
                            <Button variant="contained" color="primary" className={classes.button} onClick={() => this.handleShowDialog()}>
                                Tambah Operator
                                <AddIcon className={classes.rightIcon} />
                            </Button>

                            <DialogAdd
                                classes={this.props.classes}
                                idData={0}
                                closeDialog={this.handleCloseDialog}
                                showDialog={showDialog => this.showChildDialog = showDialog}
                            />

                            <DialogEdit openEdit={this.state.openEdit} loading={loading} handleClose={this.handleCloseEdit} data={this.state.dataEdit} />

                        </div>
                        <div className="spacer" />
                        <div className="actions">
                            <TextField
                                label={`Cari ${this.state.searchDetail}`}
                                value={this.state.search}
                                onChange={(e) => this.setState({ search: e.target.value })}
                                onKeyPress={(ev) => {
                                    if (ev.key === "Enter") {
                                        if (this.state.search)
                                            this.handleMasterDriver(0, -1);
                                    }
                                }} InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <PopupState variant="popover" popupId="popup-search">
                                                {(popupState) => (
                                                    <React.Fragment>
                                                        <IconButton
                                                            {...bindTrigger(popupState)}
                                                            aria-label="more"
                                                            aria-controls="long-menu"
                                                            aria-haspopup="true"
                                                        >
                                                            <i className="zmdi zmdi-caret-down"></i>
                                                        </IconButton>
                                                        <Menu {...bindMenu(popupState)}>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    popupState.close();
                                                                    this.setState({
                                                                        searchDetail: "Nama",
                                                                        searchDetailField: "name",
                                                                        searchTableName: "",
                                                                    });
                                                                }}
                                                            >
                                                                Nama
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    popupState.close();
                                                                    this.setState({
                                                                        searchDetail: "Kode RFID",
                                                                        searchDetailField: "rfid",
                                                                        searchTableName: "",
                                                                    });
                                                                }}
                                                            >
                                                                Kode RFID
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={(e) => {
                                                                    popupState.close();
                                                                    this.setState({
                                                                        searchDetail: "Perusahaan",
                                                                        searchDetailField: "name",
                                                                        searchTableName: "m_company",
                                                                    });
                                                                }}
                                                            >
                                                                Perusahaan
                                                            </MenuItem>
                                                        </Menu>
                                                    </React.Fragment>
                                                )}
                                            </PopupState>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                    </Toolbar>
                    <Dialog
                        open={this.state.openQr}
                        onClose={() => this.setState({ openQr: false })}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description">
                        <DialogTitle id="max-width-dialog-title">
                            {this.state.nameQr}
                            <br /><br />
                            <Divider />
                        </DialogTitle>

                        <DialogContent>
                            {/* <DialogContentText>
                            You can set multiple filter.
                            </DialogContentText> */}
                            <Grid container spacing={24}>
                                <Grid item xs={4}>
                                    <img src={this.state.urlQr}></img>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" className="bg-white text-black" onClick={() => this.setState({ openQr: false })} color="primary">
                                Close
                            </Button>

                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.state.openPhoto}
                        onClose={() => this.setState({ openPhoto: false })}
                        TransitionComponent={Transition}
                        keepMounted
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description">
                        <DialogTitle id="max-width-dialog-title">
                            {this.state.namePhoto}
                            <br /><br />
                            <Divider />
                        </DialogTitle>

                        <DialogContent>
                            {/* <DialogContentText>
                            You can set multiple filter.
                            </DialogContentText> */}
                            <Grid container spacing={24}>
                                <Grid item xs={4}>
                                    <img src={this.state.urlPhoto} width="250" height="250"></img>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" className="bg-white text-black" onClick={() => this.setState({ openPhoto: false })} color="primary">
                                Close
                            </Button>

                        </DialogActions>
                    </Dialog>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table id="tabletoexcel1">
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            padding="none"
                                        >
                                            Aksi
                                        </TableCell>
                                        {columnData.map(res => (
                                            <TableCell
                                                padding="none"
                                            >
                                                {res.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.dataDriver.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.id);
                                        return (
                                            <TableRow
                                                hover
                                                key={n.id}
                                            >
                                                <TableCell padding="none">
                                                    <Tooltip title="Edit" placement="top">
                                                        <IconButton color="primary" className="text-green" onClick={() => this.handleClickOpenEdit(n)}>
                                                            <i className="zmdi zmdi-edit"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" placement="top">
                                                        <IconButton color="primary" className="text-red" onClick={() => this.handleDeleteData(n)}>
                                                            <i className="zmdi zmdi-delete"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="View QR Code" placement="top">
                                                        <IconButton color="primary" className="text-primary" onClick={() => this.handleViewQr(n)}>
                                                            <i className="zmdi zmdi-collection-item"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="View Photo" placement="top">
                                                        <IconButton color="primary" className="text-amber" onClick={() => this.handleViewPhoto(n)}>
                                                            <i className="zmdi zmdi-collection-image"></i>
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell padding="none">{n.join.company_name}</TableCell>
                                                <TableCell padding="none">{n.name}</TableCell>
                                                <TableCell padding="none">-</TableCell>
                                                <TableCell padding="none">{n.rfid}</TableCell>
                                                <TableCell padding="none">{n.absent ? 'Yes' : 'No'}</TableCell>
                                                <TableCell padding="none">{n.status === true ? 'Active' : 'Not Active'}</TableCell>

                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={this.state.totalRecordDriver}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>
            </div>
        );
    }
}

export default withStyles(styles)(MasterDriver);


// WEBPACK FOOTER //
// ./app/routes/MasterDriver/index.js